import Permissions from "../../models/Permissions";

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: false,
  showInMenu: true,
  label: "Extratos OFX",
  icon: "fa fa-files-o",
  group: "Utilitários",
  permissions,
};

export default [
  {
    name: "Extratos",
    path: "/extratos",
    component: () => import("./Index.vue"),
    meta,
  },
];
